module.exports = __webpack_public_path__ + "img/logo.11ba9ce6.png";